export default {
	create: {
		successMessage: 'New synonym has been created.',
	},
	delete: {
		successMessage: 'Remove synonym success',
	},
};
